/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const fetchAreaCountries = async () => {
  return Request.call({
    url: `/areas/countries`,
    method: 'GET',
  });
};

export const fetchServiceProvider = async (data) => {
  return Request.call({
    url: `/serviceProviders/lists`,
    method: 'POST',
    data,
  });
};

export const fetchIntendedUsages = async () => {
  return Request.call({
    url: `/productTestings/intendedUsages`,
    method: 'GET',
  });
};

export const fetchCitations = async () => {
  return Request.call({
    url: `/citationList`,
    method: 'GET',
  });
};

export const searchCitation = async (data) => {
  return Request.call({
    url: `/citationList/search`,
    method: 'POST',
    data,
  });
};

export const fetchProductCategories = async () => {
  return Request.call({
    url: `/productCategories`,
    method: 'GET',
  });
};

export const fetchTags = async () => {
  return Request.call({
    url: `/tags`,
    method: 'GET',
  });
};

export const apiCreateNewTag = (data) => {
  return Request.call({
    url: `/tags`,
    method: 'POST',
    data,
  });
};

export const fetchCertificationTypes = () => {
  return Request.call({
    url: `/micro/factoryAudits/certificationType`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const fetchConnectedProviders = async (companyId) => {
  return Request.call({
    url: `/micro/companies/${companyId}/labs`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
